/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as PlayState from '../play/state.defs.js'
import * as GameList from './list.defs.js'

const $nsid = 'at.tastetest.game.create'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  name: /*#__PURE__*/ l.string({ minGraphemes: 1, maxGraphemes: 100 }),
  testType: /*#__PURE__*/ l.enum(['music', 'skeet']),
  maxPlayers: /*#__PURE__*/ l.integer({ minimum: 2, maximum: 20 }),
  rounds: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<PlayState.PlannedRound>(
        (() => PlayState.plannedRound) as any,
      ),
      { minLength: 1, maxLength: 20 },
    ),
  ),
  requestId: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ minLength: 36, maxLength: 36 }),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<GameList.LeagueView>((() => GameList.leagueView) as any),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
